import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'have_decisions_of_termination_forced_resignation_retrenchment_o'

export const dataPointDefinition = {
  retracedId: 'have_decisions_of_termination_forced_resignation_retrenchment_o',
  name: "Have decisions of termination, forced resignation, retrenchment or retirement been dependent upon a worker's absence due to illness?",
  description:
    'The intent of this question is to understand if absences due to worker illness (or the illness of close relatives) caused workers to be terminated or retrenched. \r\r\n\r\r\nFor example, if workers who had extended personnel leave absences from work were terminated after a period of time, the response of "Always" or "Sometimes" should be selected.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'disc-12',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 18100,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
